import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_FNF_PAYSLIP);


const state = {
    data: [],
    paySlipData: {},
    isFetching: false,
    isSaving: false,
    isDeleting: false
};

const mutations = {
    set: (state, [payload, id]) => {
        if (!state.data[id]) {
            state.data[id] = [payload];
        } else {
            state.data[id].push(payload);
        }
    },

    setPayslipData: (state, payload) => {
        state.paySlipData = payload;
    },

    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    setSaving: (state, payload) => {
        state.isSaving = payload;
    },

    setDeleting: (state, payload) => {
        state.isDeleting = payload;
    },
}

const actions = {
    async fetchAll({ commit }, payload) {
        try {
            commit("setFetching", true);
            let res = await axios_instance.get(``, { params: { le_id: payload } });
            commit("setFetching", false);
            if (res.status == 200) {
                commit("set", [res.data.payload, payload]);
            }
            return res;
        } catch (err) {
            throw errorHandler(err.response)
        }
    },

    async create({ commit }, payload) {
        try {
            commit("setSaving", true);
            let res = await axios_instance.post('/', payload);
            commit("setSaving", false);
            if (res.status == 200) {
                commit("setPayslipData", res.data.payload.data);
            }
            return res;
        } catch (err) {
            throw errorHandler(err.response)
        }
    },
    async update({ commit }, payload) {
        try {
            commit("setSaving", true);
            let res = await axios_instance.put(`/${payload.data.id}`, payload);
            commit("setSaving", false);
            if (res.status == 200) {
                commit("setPayslipData", res.data.payload.data);
            }
            return res;
        } catch (err) {
            throw errorHandler(err.response)
        }
    },

}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}